export default {
	// 是否启用埋点.
	isTrackUser: true,
	// 若启用埋点，则需要配置初始化选项.
	trackerOptions: {
		av: 1,
		as: 3,
		bu_id: 2,
		api: '//loganalytics.yunshanmeicai.com/log'
	}
}
